import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Grid } from '@mui/material';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { SelectButton } from 'primereact/selectbutton';
import { addRiskAssessment, updateRiskAssessment } from '../../service/riskAssessmentService';
import { Calendar } from 'primereact/calendar';
import {Dispatch, MutableRefObject, SetStateAction, useEffect, useState} from "react";
import {addDocument, updateDocument} from "../../service/documentsService";
import Stack from "@mui/joy/Stack";
import Input from "@mui/joy/Input";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import {InputSwitch} from "primereact/inputswitch";
import FormAllocationAddClientOverrides, {ClientOverride} from "./form-allocation-Add-frequency-override";
import {TabPanel, TabView} from "primereact/tabview";
import {appointmentsAdd, appointmentsUpdate} from "../../service/appointmentsService";
import { updateFormAllocation, addFormAllocation } from '../../service/formAllocationService';
import {FREQUENCIES} from "./constants";

interface inputProps {
  id: string,
  record: any,
  toast: MutableRefObject<any>,
  setGlobalLoader: Dispatch<SetStateAction<boolean>>,
  setVisible: Dispatch<SetStateAction<boolean>>,
  setReload: Dispatch<SetStateAction<boolean>>,
  reload: boolean
}


export default function FormAllocationAdd(modalProps: inputProps) {
  const record = modalProps.record;

  const [formId, setFormId] = useState(record?.form_id || "");
  // const [formId, setFormId] = useState(0);
  const [frequency, setFrequency] = useState(record?.frequency || []);
  const [description, setDescription] = useState(record?.description || "");
  const [industryIds, setIndustryIds] = useState(record?.industry_ids || []);
  const [appointmentIds, setAppointmentIds] = useState(record?.appointment_ids || []);
  const [clientOverrides, setClientOverrides] = useState<ClientOverride[]>(record?.client_overrides || []);



  // useEffect(() => {
  //   console.log(">>>>>>>", industryIds)
  // }, [industryIds])

  async function addOrUpdate() {
    const data = {
      form_id: formId,
      frequency,
      description,
      industry_ids: industryIds,
      appointment_ids: appointmentIds,
      client_overrides: clientOverrides,
    }

    modalProps.setGlobalLoader(true);
    if (modalProps.id) {
      console.log("updateFormAllocation == ", data, record.id);
      updateFormAllocation(data, record.id).then((r: any) => {
        modalProps.setVisible(false);
        modalProps.setGlobalLoader(false);
        modalProps.setReload(!modalProps.reload);
        modalProps.toast.current.show({ severity: 'success', summary: 'Updated Successfully', life: 3000 });
      })
    } else {
      addFormAllocation(data).then((r: any) => {
        modalProps.setVisible(false);
        modalProps.setGlobalLoader(false);
        modalProps.setReload(!modalProps.reload);
        modalProps.toast.current.show({ severity: 'success', summary: 'Added Successfully', life: 3000 });
      })
    }
  }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: 'flex', my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>

          <TabView>
            <TabPanel header="Form Allocation">
              <Stack spacing={2}>
                <Stack spacing={1}>
                  <DropdownApi apiPath='form' optionLabel="name" optionValue='id' label='Form' selectedData={formId}
                               setSelectedData={setFormId} required={true} />
                </Stack>
                <Stack spacing={1}>
                  <FormLabel>Frequency <div style={{color: 'red'}}>*</div></FormLabel>
                  <Dropdown className="PrimeSmallInput" style={{ fontSize: 'small', padding: 0 }}
                            onChange={(e: any) => setFrequency(e.value)}
                            options={FREQUENCIES}
                            value={frequency}
                            optionLabel="label"
                            optionValue="value"
                            filterBy="label"
                            placeholder={`Select Frequency`}
                            required={true}/>
                </Stack>
                <Stack spacing={1}>
                  <MultiDropdownApi apiPath='industry' optionLabel="name" optionValue='id' label='Industry'
                                    selectedData={industryIds} setSelectedData={setIndustryIds} required={true} />
                </Stack>
                <Stack spacing={1}>
                  <MultiDropdownApi apiPath='appointments' optionLabel="name" optionValue='id' label='Appointment'
                                    selectedData={appointmentIds} setSelectedData={setAppointmentIds} required={true} />
                </Stack>
                <Stack spacing={1}>
                  <FormLabel>Description</FormLabel>
                  <FormControl sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }} >
                    <InputTextarea value={description} placeholder="Document Description"
                                   onChange={e => setDescription(e.target.value)} />
                  </FormControl>
                </Stack>
              </Stack>
            </TabPanel>

            <TabPanel header={`Client Frequency Overrides (${clientOverrides.length})`}>
              <FormAllocationAddClientOverrides clientOverrides={clientOverrides} toast={modalProps.toast}
                                                onChange={(data)=> setClientOverrides(data)} />
            </TabPanel>

          </TabView>
        </Stack>
      </Stack>

      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small"
                  style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }}
                  onClick={addOrUpdate}
                   />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );

}